import { useRouter } from 'next/router';

import Button, {
  ButtonSize,
  ButtonVariant,
} from '@/components/BaseLibrary/Button/Button';
import { IconName } from '@/components/Icon/Icon';
import { trackEvents } from '@/utils/analytics';

import useStyles from './FeatureLink.styles';

type FeatureLinkProps = {
  category: string;
  title: string;
  buttonLabel: string;
  isOnDark: boolean;
  imageUrl?: string;
  url?: string;
};

const FeatureLink = ({
  category,
  title,
  imageUrl,
  buttonLabel,
  isOnDark,
  url,
}: FeatureLinkProps) => {
  const router = useRouter();
  const { classes } = useStyles({ isOnDark });

  const handleLinkInteraction = () => {
    trackEvents({
      event: 'engagement',
      id: `feature-link-${title}`,
      banner_name: title,
      nav: category,
    });
    if (url) {
      router.push(url);
    }
  };

  return (
    <div className={classes.card}>
      <div
        data-testid='background'
        className={classes.cardBackgroundImg}
        style={imageUrl ? { backgroundImage: imageUrl } : {}}
      >
        <div
          data-testid='link-container'
          className={classes.linkContainer}
          role='button' // Add button role
          tabIndex={0} // Make it focusable
          aria-label={`Navigate to ${title}`} // Add accessible label
          onClick={handleLinkInteraction} // Handle click
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              handleLinkInteraction();
            }
          }} // Handle keyboard interaction
        >
          <div className={classes.title}>{title}</div>
          <Button
            isOnDark={isOnDark}
            iconName={IconName.CHEVRON_RIGHT}
            size={ButtonSize.SM}
            variant={ButtonVariant.SECONDARY}
            label={buttonLabel}
            noPrefetchOnHover
          />
        </div>
      </div>
    </div>
  );
};

export default FeatureLink;
